import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { useClientContext } from "clients";
import type { BaseError } from "core/utils/baseError";
import Account, { dtoToAccount } from "models/account";

export const listAccountsQueryKey = "listAccounts";

/**
 * Hook for getting list of accounts for the given organization id
 *
 * caller needs to be an organization admin
 *
 * @param {number} organizationId
 * @param {(string | number)[]} queryKey
 * @returns {useQuery<Account[], BaseError>} list of accounts
 */
const useListAccounts = (
  organizationId: number,
  queryKey?: (string | number)[],
): UseQueryResult<Account[], BaseError> => {
  const clients = useClientContext();
  return useQuery<Account[], BaseError>({
    queryKey: queryKey ?? [listAccountsQueryKey, organizationId],
    queryFn: async () =>
      await clients.management
        .listAccounts(organizationId)
        .then((res) => res.map(dtoToAccount)),
  });
};

export default useListAccounts;
